// src/components/WeatherContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useChecklistDefaults } from "../context/ChecklistDefaultsContext";

const WeatherContext = createContext();

export const WeatherProvider = ({ children }) => {
  const { defaultHazard, defaultAlertType } = useChecklistDefaults();

  const [weather, setWeather] = useState(defaultHazard || "Winter Weather");
  const [alertType, setAlertType] = useState(defaultAlertType || "Seasonal");

  // Always sync weather with defaultHazard when it changes
  useEffect(() => {
    if (!defaultHazard) return;
    setWeather(defaultHazard);
  }, [defaultHazard]);

  // Always sync alertType with defaultAlertType when it changes
  useEffect(() => {
    if (!defaultAlertType) return;
    setAlertType(defaultAlertType);
  }, [defaultAlertType]);

  const updateWeather = (hazard) => setWeather(hazard);
  const updateAlertType = (type) => setAlertType(type);

  console.log("[WeatherContext] state:", {
    weather,
    alertType,
    defaultHazard,
    defaultAlertType,
  });

  return (
    <WeatherContext.Provider
      value={{ weather, updateWeather, alertType, updateAlertType }}
    >
      {children}
    </WeatherContext.Provider>
  );
};

export const useWeather = () => useContext(WeatherContext);
